<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="درگاه" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                    v-model="form.gateway_type.val"
                                    :description="form.gateway_type.inv"
                                    label="نوع درگاه"
                                    :options="[
                                        {value: '', label: 'هیچ‌کدام'},
                                        {value: '1', label:'گروه آینده مجازی امن'},
                                        {value: '2', label: 'آتیه داده پرداز - دیتابیس'},
                                        {value: '3', label:'رهیاب رایانه گستر'},
                                        {value: '4', label:'مرکز گسترش فناوری اطلاعات'},
                                        {value: '5', label:'ارمغان راه طلایی'},
                                        {value: '6', label:'پیام افزار پیک آسا (021)'},
                                        {value: '7', label:'فرهنگ و توسعه کندو'},
                                        {value: '8', label:'رهیاب پیام گستران'},
                                        {value: '9', label:'پیام افزار پیک آسا (9000)'},
                                        {value: '10', label:'راهکار سرزمین هوشمند'},
                                        {value: '11', label:'بیتل'},
                                        {value: '12', label:'12'},
                                        {value: '13', label:'13'},
                                        {value: '14', label:'14'},
                                    ]"
                                    placeholder="انتخاب کنید"
                                    @change="form.gateway_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.current_state.val"
                                        :description="form.current_state.inv"
                                        label="وضعیت جاری"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.current_state.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <label>تاریخ ایجاد</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>آخرین استفاده</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.last_activity.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.last_activity.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>درگاه‌ها</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #gateway_type="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.gateway_type)">
                                        {{data.item.gateway_type}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #is_active="data">
                                <td v-if="data.item.is_active"><CIcon name="cilCheckAlt" size="lg"/></td>
                                <td v-else><CIcon name="cilX" size="lg"/></td>
                            </template>
                            <template #current_state="data">
                                <td v-if="data.item.current_state"><CIcon name="cilCheckAlt" size="lg"/></td>
                                <td v-else><CIcon name="cilX" size="lg"/></td>
                            </template>
                            <template #action="data">
                                <td>
                                    <template>
                                    <div class="flex-container">
                                        <div v-show="$store.state.perms.can_view_sms_gateway_page"
                                            @click="redirect_to(`/gateway/${data.item.id}/details`)"
                                            v-c-tooltip.hover="'جزییات'">
                                            <CIcon name="cilListRich" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_update_sms_gateway"
                                            @click="redirect_to(`/gateway/${data.item.id}/edit`)"
                                            v-c-tooltip.hover="'ویرایش'">
                                            <CIcon name="cilPencil" size="lg"/>
                                        </div>
                                        <div v-show="$store.state.perms.can_delete_sms_gateway"
                                            @click="delete_modal=true;id=data.item.id"
                                            v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                        </div>
                                    </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="danger"
            :show.sync="delete_modal"
            >
            <p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="delete_modal=false" color="secondary">خیر</CButton>
                <CButton @click="delete_row" color="danger">بله</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'name', label: 'نام درگاه' },
                { key: 'gateway_type', label: 'نوع درگاه' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'current_state', label: 'وضعیت جاری' },
                { key: 'queue_len', label: 'حجم صف ارسال' },
                { key: 'account_balance', label: 'موجودی حساب' },
                { key: 'ping', label: 'ping' },
                { key: 'action', label: 'عملیات' }
            ],
            collapse: false,
            form: {
                name: { val: '', inv: '', v: { max: 256 } },
                gateway_type: { val: '', inv: '', v: { max: 8} },
                is_active: { val: '', inv: '', v: { max: 8 } },
                current_state: { val: '', inv: '', v: { max: 8 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
                last_activity: { val: '', inv: '', v: { max: 16 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            delete_modal: false,
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get_badge(status) {
            switch(status) {
                default: return 'secondary';
            }
        },
        get() {
            if (this.disable == false) {
                this.offset = 0;
                if(this.page != 1){
                    this.offset = (this.page * this.limit) - this.limit;
                }
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at' || key == 'last_activity') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else {
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('sms_gateways/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                    })
                .finally(() => {
                    this.axios.get('sms_gateways/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                switch(val.gateway_type){
                                    case 1:
                                        val.gateway_type = 'گروه آینده مجازی امن';
                                        break;
                                    case 2:
                                        val.gateway_type = 'آتیه داده پرداز - دیتابیس';
                                        break;
                                    case 3:
                                        val.gateway_type = 'رهیاب رایانه گستر';
                                        break;
                                    case 4:
                                        val.gateway_type = 'مرکز گسترش فناوری اطلاعات';
                                        break;
                                    case 5:
                                        val.gateway_type = 'ارمغان راه طلایی';
                                        break;
                                    case 6:
                                        val.gateway_type = 'پیام افزار پیک آسا (021)';
                                        break;
                                    case 7:
                                        val.gateway_type = 'فرهنگ و توسعه کندو';
                                        break;
                                    case 8:
                                        val.gateway_type = 'رهیاب پیام گستران';
                                        break;
                                    case 9:
                                        val.gateway_type = 'پیام افزار پیک آسا (9000)';
                                        break;
                                    case 10:
                                        val.gateway_type = 'راهکار سرزمین هوشمند';
                                        break;
                                    case 11:
                                        val.gateway_type = 'بیتل';
                                        break;
                                }
                                val.account_balance = String(val.account_balance).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
        delete_row() {
			this.axios.delete('sms_gateways/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_sms_gateway_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
